package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

data class Author(
    val id: Int,
    val username: String? = null,
)

data class Post(
    val id: Int,
    val title: String,
    val contentMarkdown: String,
    val contentHtml: String? = null,
    val imageUrl: String? = null, // Deprecated: for backwards compatibility
    val imageIds: List<Int> = emptyList(),
    val images: List<PostImage>? = null, // Only in detail response
    val tags: List<Tag>? = null, // Only in detail response
    val status: String? = null,
    val createdAt: Instant,
    val updatedAt: Instant,
    val authorId: Int,
    val author: Author? = null,
)

/**
 * Image associated with a post
 */
data class PostImage(
    val id: Int,
    val url: String,
    val originalName: String,
    val mimeType: String,
    val width: Int? = null,
    val height: Int? = null,
    val caption: String? = null,
    val altText: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
)
